import { render, staticRenderFns } from "./Swap.vue?vue&type=template&id=148a237b&scoped=true&"
import script from "./Swap.vue?vue&type=script&lang=ts&"
export * from "./Swap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a237b",
  null
  
)

export default component.exports